import React from 'react';
import classnames from 'classnames';
import { themr } from 'react-css-themr';

import { Loader } from 'common/components/core/loader/Loader';
import theme from 'common/components/core/image/Image.scss';
import Icon from 'common/components/core/icon';
import Tooltip from 'common/components/core/tooltip';

const isImageType = src => /\.(gif|jpg|jpeg|tiff|png)$/i.test(src);

const ImageStatus = {
    LOADED: 'loaded',
    LOADING: 'loading',
    ERROR: 'error'
};

class Document extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            imageStatus: isImageType(props.src)
                ? ImageStatus.LOADING
                : ImageStatus.LOADED
        };
    }

    handleImageLoaded = () => {
        this.setState({ imageStatus: ImageStatus.LOADED });
    };

    handleImageErrored = () => {
        this.setState({ imageStatus: ImageStatus.ERROR });
    };

    renderFile() {
        const errorActive = this.state.imageStatus === ImageStatus.ERROR;
        const { src, theme } = this.props;
        if (isImageType(src)) {
            return (
                <img
                    src={src}
                    onLoad={this.handleImageLoaded}
                    onError={this.handleImageErrored}
                    className={classnames({
                        [theme.error]: errorActive
                    })}
                />
            );
        }

        return (
            <div className={theme.fileType}>
                <Icon theme={theme} icon="document-check" />
            </div>
        );
    }

    render() {
        const loaderActive = this.state.imageStatus === ImageStatus.LOADING;
        const errorActive = this.state.imageStatus === ImageStatus.ERROR;
        const { className, src, children, theme, ...other } = this.props;
        return (
            <div
                data-toolbox="image-wrap"
                {...other}
                className={classnames(theme.imageWrap, className, {
                    [theme.loaderActive]: loaderActive
                })}
            >
                <a
                    href={src}
                    target={'_blank'}
                    className={classnames(theme.imageLink)}
                >
                    {this.renderFile()}
                </a>
                <Loader active={loaderActive} theme={theme} />
                <div
                    className={classnames(theme.errorWrap, {
                        [theme.errorActive]: errorActive
                    })}
                >
                    <Icon value={'error'} />
                </div>
                {children}
            </div>
        );
    }
}

const ThemedDocument = themr('Document', theme)(Document);
const ThemedDocumentWithTooltip = Tooltip(ThemedDocument);
const DocumentWithTooltip = ({ src, theme }) => {
    return (
        <ThemedDocumentWithTooltip
            theme={theme}
            tooltip={
                isImageType(src) ? (
                    <ThemedDocument
                        theme={theme}
                        src={src}
                        className={theme.tooltipImage}
                    />
                ) : null
            }
            src={src}
        />
    );
};
const DocumentWithTooltipThemed = themr(
    'ImageWithTooltip',
    theme
)(DocumentWithTooltip);
export {
    ThemedDocument as Document,
    DocumentWithTooltipThemed as DocumentWithTooltip
};
export default ThemedDocument;
